import {Spinner} from '@primer/react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function MergingStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Merging) return null

  return <Spinner size="small" className="color-fg-done" style={{marginLeft: -2}} />
}
